const salesrepConfig = {
  goalsBy: 'Vendor',
  adminGoalsBy: '',
  dashboardActivityType: 'Store Appointment',
  showroomActivityType: 'Show Appointment',
  hideExecutiveDashboard: false,
  hideDashboardProjectedSales: false,
  includeInactive: true,
  chartColors: ['#5EBEBC', '#EB474A', '#F6B25F', '#A29A9A', '#5B8ECF'],
  showNewCustomerVendorCountWidget: false,
  hideDashboardB2BOnHoldOrders: true,
  hideDashboardPendingOrders: true,
  hideDashboardCreditHoldOrders: true,
  hideDashboardCreditHoldCorporateOrders: true,
  hideDashboardPastDueInvoices: true,
  hideDashboardCustomersPastDue: true,
  hideDashboardActivityAndNotes: false,
  hideDashboardSalesBySegment: false,
  hideDashboardNetRetailerGrowth: false,
  hideDashboardOrderContainer: false,
  hideDashboardRecentOrders: false,
  hideDashboardSalesBySource: false,
  hideDashboardThisWeek: false,
  ManagerActionRepOrderBy: '-TotalRoadBooked',
  hideDashboardNotifications: false,
  showSalesBySegment: false,
  topUnderPerformersSlice: 10,
  limitVendorByRepGroup: true,
	hideDashboardInvoiceBlocks: true
};

export default salesrepConfig;